// frontend/lib/stores/appStore.ts
import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

type AppState = {
  pageTitle: string;
  pageSubtitle?: string;
  breadcrumb?: Array<{ label: string; href?: string }>;
  isLoading?: boolean;
  // 以后可以继续扩展...
};

const initialState: AppState = {
  pageTitle: '',
  pageSubtitle: '',
  breadcrumb: [],
  isLoading: false,
};

const store = writable<AppState>(initialState);

export const appStore = {
  ...store,

  // 便捷方法
  setTitle(title: string) {
    store.update(state => ({ ...state, pageTitle: title }));
  },

  setSubtitle(subtitle: string) {
    store.update(state => ({ ...state, pageSubtitle: subtitle }));
  },

  setBreadcrumb(breadcrumb: AppState['breadcrumb']) {
    store.update(state => ({ ...state, breadcrumb }));
  },

  reset() {
    store.set(initialState);
  }
};